import { PROGRAM_STATE } from '@resources/lms-management/program/types'
import { ParticipantDetail } from '@resources/lms-management/participant-management/type'
import {
  TPrimerParticipantField,
  TPrimerParticipantValues,
  TUpdatePrimerParticipantRequest,
} from './types'

export const PRIMER_PARTICIPANT_RESOURCE = 'primer-participants'
export const PRIMER_PARTICIPANT_TITLE = 'Ubah Data Primer Partisipan'
export const REPRINT_WARNING =
  'Sertifikat yang sudah terbit akan dibuat ulang. Jika sertifikat menggunakan TTE, pejabat terkait harus melakukan proses TTE ulang. Proses ini hanya berlaku untuk sertifikat peserta yang dipilih dan tidak memengaruhi validitas sertifikat peserta lainnya.'

export const PRIMER_FIELDS: { key: TPrimerParticipantField; label: string }[] =
  [
    { key: 'name', label: 'Nama' },
    { key: 'jenjang', label: 'Jenjang' },
    { key: 'participant_type', label: 'Tipe Partisipan' },
    { key: 'jenis_ptk', label: 'Jenis PTK' },
    { key: 'nama_sekolah', label: 'Nama Sekolah' },
    { key: 'jabatan', label: 'Jabatan' },
  ]

export const JENJANG_OPTIONS = [
  'TK',
  'PAUD',
  'SD',
  'SMP',
  'SMA',
  'SMK',
  'SLB',
  'Sekolah Rakyat',
]

export const PARTICIPANT_TYPE_OPTIONS = [
  'guru',
  'non-guru',
  'pengawas sekolah',
] as const

export const canEditPrimerParticipants = (status?: string) =>
  status === PROGRAM_STATE.RUNNING || status === PROGRAM_STATE.ENDED

export const getPrimerParticipantValues = (rows: ParticipantDetail[]) =>
  Object.fromEntries(
    PRIMER_FIELDS.map(({ key }) => [
      key,
      rows.find(({ label }) => label === key)?.value ?? '',
    ]),
  ) as TPrimerParticipantValues

export const getChangedPrimerFields = (
  baseline: TPrimerParticipantValues,
  values: TPrimerParticipantValues,
) => PRIMER_FIELDS.filter(({ key }) => values[key] !== baseline[key])

export const buildPrimerParticipantRequest = (
  baseline: TPrimerParticipantValues,
  values: TPrimerParticipantValues,
  reprint: boolean,
  programStatus: string,
): TUpdatePrimerParticipantRequest => {
  if (!canEditPrimerParticipants(programStatus)) {
    throw new Error(
      'Data primer hanya dapat diubah pada program berjalan atau selesai',
    )
  }

  const changedFields = getChangedPrimerFields(baseline, values)
  if (!changedFields.length) {
    throw new Error('Ubah minimal satu field sebelum menyimpan')
  }

  if (
    changedFields.some(({ key }) => key === 'participant_type') &&
    !PARTICIPANT_TYPE_OPTIONS.some((type) => type === values.participant_type)
  ) {
    throw new Error('Pilih tipe partisipan yang valid')
  }

  if (reprint && programStatus !== PROGRAM_STATE.ENDED) {
    throw new Error(
      'Cetak ulang sertifikat hanya tersedia pada program selesai',
    )
  }

  return {
    data: Object.fromEntries(
      changedFields.map(({ key }) => [key, values[key]]),
    ) as TUpdatePrimerParticipantRequest['data'],
    ...(reprint ? { reprint_certificate: true } : {}),
  }
}
